import React from 'react';
import { useTranslation } from 'react-i18next';

import { GuideProgress } from '../../../theme/components/GuideProgress';
import { importJobProgress, isImportJobActive } from '../../../functions/ImportJobs.Functions';
import { ProviderImportJob } from '../../../models/Entities/ProviderConsumptionImport/ProviderConsumptionImport';

export interface ImportJobProgressBarProps {
  job: ProviderImportJob;
  size?: 'medium' | 'small';
  /** Texto secundario debajo de la barra. */
  detail?: React.ReactNode;
  'data-testid'?: string;
}

/**
 * Avance de un job de importación (spec 008) con `GuideProgress`: etapa del backend (o "En cola") y porcentaje;
 * barra indeterminada mientras el backend no informa avance. Lo usan el asistente, el banner y el historial.
 */
export const ImportJobProgressBar = ({ job, size = 'medium', detail, ...rest }: ImportJobProgressBarProps) => {
  const { t } = useTranslation();
  const stage = job.stage?.trim() || t('providerConsumptionImport.jobs.queuedStage');
  const value = importJobProgress(job);
  return (
    <GuideProgress
      value={value}
      label={stage}
      size={size}
      detail={detail}
      ariaLabel={t('providerConsumptionImport.jobs.progressLabel', { name: job.fileName ?? '' })}
      valueText={value === undefined ? stage : t('providerConsumptionImport.jobs.progressValue', { stage, progress: value })}
      tone={isImportJobActive(job) ? 'brand' : 'success'}
      data-testid={rest['data-testid']}
    />
  );
};

export default ImportJobProgressBar;
